export function getEmailFromToken(token) {
    if (!token) {
        return null;
    }

    try {
        const payload = token.split('.')[1];
        if (!payload) {
            return null;
        }

        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = JSON.parse(atob(normalized));

        return decoded.email ?? null;
    } catch {
        return null;
    }
}

export function getSessionEmail() {
    const token = localStorage.getItem('userToken');
    return getEmailFromToken(token) ?? localStorage.getItem('email') ?? '';
}

export function syncSessionEmailFromToken(token = localStorage.getItem('userToken')) {
    const email = getEmailFromToken(token);
    if (email) {
        localStorage.setItem('email', email);
    }
    return email;
}
